import React from 'react';
import { FadeInUp } from './ui/FadeInUp';
import { SectionEyebrow } from './ui/SectionEyebrow';
import { TrendingUp, TrendingDown } from 'lucide-react';
const stats = [{
  label: 'Active Listings',
  value: '25,267',
  change: '+3.73%',
  isPositive: true
}, {
  label: 'Days on Market',
  value: '67',
  change: '-5.63%',
  isPositive: false
}, {
  label: 'Median Price',
  value: '$450,000',
  change: '+1.12%',
  isPositive: true
}, {
  label: 'Months of Supply',
  value: '4.42',
  change: '-14.01%',
  isPositive: false
}, {
  label: 'Sales',
  value: '5,711',
  change: '+20.64%',
  isPositive: true
}, {
  label: 'Percent of List',
  value: '92.0%',
  change: '-1.50%',
  isPositive: false
}];
export function MarketStatsSection() {
  return <section className="py-24 md:py-32 bg-charcoal text-ivory" data-id="element-213">
      <div className="container mx-auto px-6" data-id="element-214">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16 md:mb-24 gap-8" data-id="element-215">
          <FadeInUp className="max-w-2xl" data-id="element-216">
            <SectionEyebrow text="Phoenix Metro Market Pulse" className="!text-terracotta" data-id="element-217" />
            <h2 className="text-4xl md:text-5xl font-serif mb-6 text-balance" data-id="element-218">
              Real numbers. Real time. Real expertise.
            </h2>
            <p className="text-ivory/70 text-lg" data-id="element-219">
              Updated monthly. Because data drives smart decisions.
            </p>
          </FadeInUp>
          <FadeInUp delay={0.2} data-id="element-220">
            <a href="#" className="inline-block px-8 py-4 bg-terracotta text-white rounded font-medium hover:bg-terracotta/90 transition-colors shadow-lg" data-id="element-221">
              Get a Custom Market Report
            </a>
          </FadeInUp>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-xl overflow-hidden" data-id="element-222">
          {stats.map((stat, index) => <FadeInUp key={stat.label} delay={index * 0.05} className="bg-charcoal p-8 md:p-10" data-id="element-223">
              <div className="text-[10px] md:text-xs font-semibold uppercase tracking-widest text-ivory/50 mb-4" data-id="element-224">
                {stat.label}
              </div>
              <div className="flex items-baseline gap-4" data-id="element-225">
                <div className="text-4xl md:text-5xl font-serif text-ivory" data-id="element-226">
                  {stat.value}
                </div>
                <div className={`flex items-center text-sm font-medium ${stat.isPositive ? 'text-green-400' : 'text-terracotta'}`} data-id="element-227">
                  {stat.isPositive ? <TrendingUp className="w-4 h-4 mr-1" data-id="element-228" /> : <TrendingDown className="w-4 h-4 mr-1" data-id="element-229" />}
                  {stat.change}
                </div>
              </div>
            </FadeInUp>)}
        </div>

        <FadeInUp delay={0.4} className="mt-8 text-center lg:text-left" data-id="element-230">
          <p className="text-xs text-ivory/40" data-id="element-231">
            Data reflects February 1 to March 1, 2026. The percentage shows
            change from the previous month of the same year.
          </p>
        </FadeInUp>
      </div>
    </section>;
}